"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var card_1 = require("@angular/material/card");
var button_1 = require("@angular/material/button");
var menu_1 = require("@angular/material/menu");
var toolbar_1 = require("@angular/material/toolbar");
var icon_1 = require("@angular/material/icon");
var radio_1 = require("@angular/material/radio");
var form_field_1 = require("@angular/material/form-field");
var input_1 = require("@angular/material/input");
var select_1 = require("@angular/material/select");
var checkbox_1 = require("@angular/material/checkbox");
var paginator_1 = require("@angular/material/paginator");
var paginator_2 = require("@angular/material/paginator");
var list_1 = require("@angular/material/list");
var progress_spinner_1 = require("@angular/material/progress-spinner");
var sidenav_1 = require("@angular/material/sidenav");
var tooltip_1 = require("@angular/material/tooltip");
function getCustomPaginatorLabel() {
    var paginatorIntl = new paginator_2.MatPaginatorIntl();
    var rangeLabel = function (page, pageSize, length) {
        var allPages = Math.ceil(length / pageSize);
        if (length == 0 || pageSize == 0) {
            return "Page 1 of " + allPages;
        }
        return "Page " + (page + 1) + " of " + allPages;
    };
    paginatorIntl.nextPageLabel = 'Next';
    paginatorIntl.previousPageLabel = 'Previous';
    paginatorIntl.getRangeLabel = rangeLabel;
    return paginatorIntl;
}
var modules = [
    button_1.MatButtonModule,
    menu_1.MatMenuModule,
    toolbar_1.MatToolbarModule,
    icon_1.MatIconModule,
    card_1.MatCardModule,
    radio_1.MatRadioModule,
    form_field_1.MatFormFieldModule,
    input_1.MatInputModule,
    select_1.MatSelectModule,
    checkbox_1.MatCheckboxModule,
    paginator_1.MatPaginatorModule,
    list_1.MatListModule,
    progress_spinner_1.MatProgressSpinnerModule,
    sidenav_1.MatSidenavModule,
    tooltip_1.MatTooltipModule
];
var ɵ0 = getCustomPaginatorLabel();
exports.ɵ0 = ɵ0;
var MaterialModule = /** @class */ (function () {
    function MaterialModule() {
    }
    return MaterialModule;
}());
exports.MaterialModule = MaterialModule;
